export const otherNewsCheckerModule = {
  name: 'Other News Checker',
};
